module.exports = {
      id: "icon-benifits-search-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#icon-benifits-search-usage",
      toString: function () {
        return this.url;
      }
    }